import { useCallback, useMemo } from 'react';
import { bindActionCreators } from '@reduxjs/toolkit';

import { actions } from '../store/drawer.slice';

import { useAppDispatch } from './use-app-dispatch';
import { useAppSelector } from './use-app-selector';

export const useDrawer = () => {
  const dispatch = useAppDispatch();
  const drawerState = useAppSelector((state) => state.drawer.state);

  const { open, close } = useMemo(
    () => bindActionCreators(actions, dispatch),
    [dispatch],
  );

  const openCallback = useCallback(() => open(), [open]);
  const closeCallback = useCallback(() => close(), [close]);

  return {
    open: openCallback,
    close: closeCallback,

    state: drawerState,
    isOpen: drawerState === 'open',
    isClosed: drawerState === 'closed',
  };
};
